///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>

module ProcessEditor {

    export class CobaltParameterEditorController {
        public node: TaskNode;
        /** Parent controller */
        public ctrl: ng.INgModelController;
        public parameters: ITaskParameter[];
        public sourceEndpointConfig;
        public destinationEndpointConfig;
        public transferConfig;
        public messageProcessingSteps;

        originalParameters: ITaskParameter[];

        static $inject = ['$scope'];

        constructor(private $scope: ng.IScope) {
            this.originalParameters = this.parameters;
            $scope.$watch(() => this.parameters, (newValue: ITaskParameter[], oldValue, scope) => {
                if (newValue !== this.originalParameters) {
                    this.originalParameters = newValue;
                    this.mapParameters();
                }
            });
            this.mapParameters();
        }

        private setDefaultValues(param: ITaskParameter) {
            if (!param.value && param.defaultValue) {
                param.value = param.defaultValue.toString();
            }
            if (param.subParameters) {
                param.subParameters.forEach(p => this.setDefaultValues(p));
            }

            return param;
        }

        private mapParameters() {
            this.sourceEndpointConfig = this.getEndpointConfig(this.getParam(this.parameters, "source"));
            this.destinationEndpointConfig = this.getEndpointConfig(this.getParam(this.parameters, "destination"));

            let transferParams = this.getParam(this.parameters, "transferParameters").subParameters;
            this.transferConfig = {
                transferName: this.getParam(this.parameters, "transferName"),
                transferLoggerName: this.getParam(this.parameters, "transferLoggerName"),
                workDir: this.getParam(this.parameters, "workDir"),
                processUri: this.getParam(this.parameters, "processUri"),
                taskExecutionId: this.getParam(this.parameters, "taskExecutionId"),
                throwErrorOnFail: this.getParam(this.parameters, "throwErrorOnFail"),
                transferParams: transferParams
            }

            let messageProcessingStepObj = this.getParam(this.parameters, "messageProcessingSteps");
            this.messageProcessingSteps = messageProcessingStepObj.subParameters;
            if (this.messageProcessingSteps.length === 0) {


                // no ready steps -> just add some defaults, because the array adding does not yet work
                let template = messageProcessingStepObj.parameterTemplate;
                // set the default to PassThrough
                var templateTypeParam = this.getParam(template.subParameters, "Type");
                templateTypeParam.value = "PassThrough";

                this.messageProcessingSteps.push(this.setDefaultValues(angular.copy(template)));
                this.messageProcessingSteps.push(this.setDefaultValues(angular.copy(template)));
                this.messageProcessingSteps.push(this.setDefaultValues(angular.copy(template)));
            }

            this.messageProcessingSteps = this.messageProcessingSteps
                .map(p => {
                    return {
                        type: this.getParam(p.subParameters, "Type"),
                        fileSystemBackupParameters: this.getParam(p.subParameters, "FileSystemBackup"),
                        xsltParameters: this.getParam(p.subParameters, "Xslt"),
                        encodingParameters: this.getParam(p.subParameters, "Encoding"),
                        bulkLogParameters: this.getParam(p.subParameters, "BulkLog"),
                        customParameters: this.getParam(p.subParameters, "Custom"),
                        localBackupParameters: this.getParam(p.subParameters, "LocalBackup")
                    }
                });
        }

        private getEndpointConfig(p: ITaskParameter) {
            // The file sub-parameters were added only after Cobalt beta (3.0.45) was released.
            // We need to support also editing of the older format.
            let fileParams = this.getParam(p.subParameters, "file");

            return {
                type: this.getParam(p.subParameters, "type"),
                name: this.getParam(p.subParameters, "name"),
                fileName: this.getParam(p.subParameters, "fileName"),
                directory: this.getParam(p.subParameters, "directory"),
                fileParameters: fileParams && fileParams.subParameters,
                serverParameters: this.getParam(p.subParameters, "server").subParameters,
                ftpParameters: this.getParam(p.subParameters, "ftp").subParameters,
                ftpsParameters: this.getParam(p.subParameters, "ftps").subParameters,
                sftpParameters: this.getParam(p.subParameters, "sftp").subParameters,
                serviceBusParameters: this.getParam(p.subParameters, "servicebus").subParameters,
                customParameters: this.getParam(p.subParameters, "custom").subParameters
            }
        }

        private getParam(params: ITaskParameter[], name: string): ITaskParameter {
            return _.find(params, p => p.name.toLowerCase() === name.toLowerCase());
        }

    }

    app.controller("cobaltParameterEditorController", CobaltParameterEditorController);

    export function cobaltParameterEditorDirective(): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "cobaltParameterEditor.htm",
            controller: "cobaltParameterEditorController",
            controllerAs: "cobaltCtrl",
            bindToController: true,
            scope: {
                parameters: "=",
                ctrl: "=",
                node: "="
            }
        }
    }

    app.directive("frendsCobaltParameterEditor", cobaltParameterEditorDirective);
}